export default class LabelEstilo {
    static get VERDE() {
        return {
            color: '#359138',
            'border-color': '#E3F3DA',
            'background-color': '#F0F9EB'
        };
    }

    static get AMARELO() {
        return {
            color: '#E89924',
            'border-color': '#FBEFDD',
            'background-color': '#FDF6EC'
        };
    }

    static get VERMELHO() {
        return {
            color: '#F56C6C',
            'border-color': '#FDE2E2',
            'background-color': '#FEF0F0'
        };
    }

    static get CINZA() {
        return {
            color: '#607d8b',
            'border-color': '#cfd8dc',
            'background-color': '#eceff1'
        };
    }

    static get CANCELADO() {
        return {
            color: '#757575',
            'border-color': '#e0e0e0',
            'background-color': '#f5f5f5'
        };
    }

    static getByName(name) {
        if (!name) return;
        name = name.toUpperCase();
        return LabelEstilo[name];
    }
};
